import styled from "styled-components";

import { actionListSubtitle } from "../../../shared/styles/typography";

export { Container, Main } from "../../../styles/adminPage";

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  margin-bottom: 2.4rem;
`;

export const FooterConfig = styled.footer`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1.6rem;
  padding-top: 1.6rem;
  border-top: 1px solid ${({ theme }) => theme.colors.border};
  margin-top: 2.4rem;

  p {
    display: flex;
    align-items: center;
    gap: 1rem;
    ${actionListSubtitle}
    margin: 0;
  }
`;
